import { FC } from "react";
import { KTIcon } from "../../../../../_metronic/helpers";

interface Props {
  onCancel: () => void;
}

export const UserReverifyModalHeader: FC<Props> = ({ onCancel }) => {
  return (
    <div className="modal-header">
      {/* begin::Modal title */}
      <h2 className="fw-bolder mb-0">Подтвердите вход</h2>
      {/* end::Modal title */}

      {/* begin::Close (закрытие = отмена → логаут) */}
      <div
        className="btn btn-icon btn-sm btn-primary btn-active-icon-light"
        data-kt-users-modal-action="close"
        onClick={onCancel}
        style={{ cursor: "pointer" }}
      >
        <KTIcon iconName="cross" className="fs-1" />
      </div>
      {/* end::Close */}
    </div>
  );
};
